<template>
  <wrapper class="mb-5">
    <print-article
      v-for="article in articlesToPrint"
      :key="`print-article-${article.id}`"
      :article="article"
      :labels="article.labels"
      :connector="connector"
      @updateLabelQuantity="updateLabelQuantity"
    />
    <g-button
      :disabled="labelsToPrint.length === 0"
      class="float-right primary"
      @click="printerSelectOpen = true"
      >Select printers</g-button
    >
    <printer-select
      :key="`printer-select--${componentKey}`"
      v-if="showPrinterSelect"
      @close="printerSelectOpen = false"
      :labels="labelsToPrint"
      :printers="printers"
      :presetprinter="presetprinter"
      :autoprint="autoprint"
      :connector="connector"
      :enable-print-to-group="enablePrintToGroup"
    />
  </wrapper>
</template>
<script>
import Wrapper from "./Wrapper";
import PrintArticle from "./PrintArticle";
import GButton from "./forms/Button";
import PrinterSelect from "./PrinterSelect";

export default {
  components: {
    Wrapper,
    PrintArticle,
    GButton,
    PrinterSelect,
  },
  data: () => ({
    articlesToPrint: [],
    labelsToPrint: [],
    printerSelectOpen: null,
    componentKey: 0,
  }),
  props: {
    autoprint: {
      type: Boolean,
      default: false,
    },
    articles: {
      type: Array,
      required: true,
    },
    connector: {
      type: String,
      required: false
    },
    enablePrintToGroup: {
      type: Boolean,
      default: false,
    },
    presetprinter: {
      type: String,
      default: null,
    },
  },
  methods: {
    updateLabelQuantity(event) {
      const article = this.articlesToPrint.find(a => a.id === event.article.id);
      const label = article.labels.find(l => l.labelId === event.label.labelId);
      label.quantity = event.quantity;
      this.labelsToPrint = this.articlesToPrint
        .flatMap(a =>
          a.labels.map(l => ({
            ...l,
            article: a,
          }))
        )
        .filter(l => l.quantity && l.quantity > 0);

      this.componentKey++;
    },
  },
  computed: {
    printers() {
      return this.$store.getters["PRINTERS/INSTALLED_PRINTERS"];
    },
    showPrinterSelect() {
      return (
        (this.autoprint && this.printerSelectOpen === null) ||
        this.printerSelectOpen === true
      );
    },
  },
  mounted() {
    this.articlesToPrint = this.articles;
    if (this.printers.length === 0) {
      this.$store.dispatch("PRINTERS/GET_INSTALLED_PRINTERS");
    }
  },
};
</script>
